/* eslint-disable quotes */
import { defineComponent, h } from "vue";
import { Dialog, utility } from '@phi/components';
import { abort_projecting_edges_onto_faces, process_modal_for_project_edges_onto_faces } from '@frontend/ui_display';

const body = `<fieldset>
    <div>
        Select the projection type and direction:
    </div>

    <div>
        <select id="project-edges-type" class="modal-input long" style='width: auto'>
            <option value="face">Onto one or more faces</option>
            <option value="plane">Perpendicular to an X/Y/Z plane</option>
            <option value="edge">Along a linear edge</option>
            <option value="view">Along a selected view direction</option>
        </select>
    </div>
</fieldset>

<fieldset>
    <div>
        Offset: Can be positive (projection passes behind target) or negative (a gap is left between projection and target):
    </div>

    <div>
        <input id="project-edges-offset" class="modal-input" placeholder="0" autocomplete="off"/>
    </div>
</fieldset>`;

export default defineComponent({
    props: {
        show: { required: true, type: Boolean},
    },

    emits: {
        'update:show': (x: boolean) => true,
    },

    render() {
        return h(Dialog, {
            show: this.show,
            'onUpdate:show': x => {
                if (!x)
                    abort_projecting_edges_onto_faces();
            },
            onClose: abort_projecting_edges_onto_faces,
            close_label: 'Cancel',
            confirm_label: 'Proceed',
            onConfirm: process_modal_for_project_edges_onto_faces,
            id: 'projectEdgesOffset',
            title: 'Project selected edges',
            width: 'narrower',
        }, () => h('div', { class: utility.margin_gap_5, innerHTML: body }));
    }
});
